import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DMI_SERVICE_AUTO_TRIGGER_ENABLED = createFcmDetails('dmi_service_auto_trigger_enabled', {
	owner: 'Data Platform',
	context: 'petition_service',
	description: 'Enables automatic addition of AI recommended DMs on petitions',
	import: false,
});
